(function () {
  const BODY_CLASS = 'sticky-atc-pdp-visible';

  function initStickyAtc() {
    const sticky = document.querySelector('.sticky-atc-pdp');
    if (!sticky || sticky.dataset.initialized === 'true') return;

    const productPage =
      sticky.closest('product-page') || document.querySelector('product-page');
    if (!productPage) return;

    const mainAtcAnchor =
      productPage.querySelector('.product__cart-actions-holder') ||
      productPage.querySelector('.product__cart-actions') ||
      productPage.querySelector('product-form');
    const mainAtcButton =
      productPage.querySelector('.product__cart-actions .product__add-to-cart') ||
      productPage.querySelector('.product__add-to-cart') ||
      productPage.querySelector('.add-to-cart-btn');
    const mainAtc = mainAtcAnchor || mainAtcButton;
    if (!mainAtc) return;

    sticky.dataset.initialized = 'true';

    const sectionId = sticky.dataset.sectionId;
    const titleEl = sticky.querySelector('.sticky-atc-pdp__title');
    const variantsMount = sticky.querySelector('[data-sticky-variants]');
    const imageEl = sticky.querySelector('.sticky-atc-pdp__image');
    const stickyBtn = sticky.querySelector('[data-sticky-atc-trigger]');
    const stickyBtnText = stickyBtn?.querySelector('.add-to-cart__text');
    const mainTitle = productPage.querySelector('.product__title');

    if (mainTitle && titleEl) {
      titleEl.innerHTML = mainTitle.innerHTML;
    }

    const productVariants = productPage.querySelector(
      `product-variants[data-id="${sectionId}"]`
    );

    let syncing = false;

    function getMainVariantsRoot() {
      const inPicker = productPage.querySelector(
        'product-variants .product__variants'
      );
      if (inPicker) return inPicker;

      const inSwatches = productPage.querySelector(
        '.variant-swatches-container .product__variants'
      );
      if (inSwatches) return inSwatches;

      return productPage.querySelector('.product__variants');
    }

    function getStickyVariantsRoot() {
      return variantsMount?.querySelector('.product__variants') || null;
    }

    function updateShadeLabelInGroup(group, value) {
      if (!group || value == null) return;
      group.querySelectorAll('.concealer-selected-shade span').forEach((el) => {
        el.textContent = value;
      });
    }

    function updateShadeLabelsFromVariant(variant) {
      if (!variant) return;
      const values = variant.options || [];
      const roots = [getMainVariantsRoot(), getStickyVariantsRoot()].filter(
        Boolean
      );
      roots.forEach((root) => {
        root.querySelectorAll('.product-variant').forEach((group, index) => {
          if (values[index] != null) {
            updateShadeLabelInGroup(group, values[index]);
          }
        });
      });
    }

    const swatchNavUpdaters = [];
    const ARROW_GUTTER_PX = 52;
    let isStickyShown = false;
    let swatchNavActive = false;
    let visibilityRaf = 0;

    function setupStickySwatchScroll(stickyRoot) {
      if (!stickyRoot) return;

      stickyRoot.querySelectorAll('.product-variant').forEach((variantEl) => {
        const container = variantEl.querySelector('.product-variant__container');
        if (!container || container.closest('.sticky-atc-pdp__swatches-scroll')) {
          return;
        }

        const scrollWrap = document.createElement('div');
        scrollWrap.className = 'sticky-atc-pdp__swatches-scroll';

        const prev = document.createElement('button');
        prev.type = 'button';
        prev.className =
          'sticky-atc-pdp__swatch-nav sticky-atc-pdp__swatch-nav--prev';
        prev.setAttribute('aria-label', 'Scroll shades left');
        prev.innerHTML =
          '<svg width="8" height="14" viewBox="0 0 8 14" aria-hidden="true"><path d="M7 1L1 7l6 6" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>';

        const track = document.createElement('div');
        track.className = 'sticky-atc-pdp__swatches-track';

        const next = document.createElement('button');
        next.type = 'button';
        next.className =
          'sticky-atc-pdp__swatch-nav sticky-atc-pdp__swatch-nav--next';
        next.setAttribute('aria-label', 'Scroll shades right');
        next.innerHTML =
          '<svg width="8" height="14" viewBox="0 0 8 14" aria-hidden="true"><path d="M1 1l6 6-6 6" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>';

        scrollWrap.append(prev, track, next);
        variantEl.appendChild(scrollWrap);
        track.appendChild(container);

        let navRaf = 0;
        const updateNav = () => {
          if (!swatchNavActive) return;
          if (navRaf) return;
          navRaf = requestAnimationFrame(() => {
            navRaf = 0;
            if (!swatchNavActive) return;

            const contentWidth = Math.ceil(container.scrollWidth);
            const wrapWidth = Math.ceil(scrollWrap.clientWidth);
            const hadOverflow = scrollWrap.classList.contains('has-overflow');
            const visibleWidth = hadOverflow
              ? wrapWidth - ARROW_GUTTER_PX
              : wrapWidth;
            const diff = contentWidth - visibleWidth;
            const hasOverflow = hadOverflow ? diff > -4 : diff > 8;
            const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);

            if (hasOverflow !== hadOverflow) {
              scrollWrap.classList.toggle('has-overflow', hasOverflow);
            }
            prev.disabled = !hasOverflow || track.scrollLeft <= 1;
            next.disabled = !hasOverflow || track.scrollLeft >= maxScroll - 1;
          });
        };

        swatchNavUpdaters.push(updateNav);

        prev.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          track.scrollBy({ left: -120, behavior: 'smooth' });
        });

        next.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          track.scrollBy({ left: 120, behavior: 'smooth' });
        });

        track.addEventListener('scroll', updateNav, { passive: true });
        if (typeof ResizeObserver !== 'undefined') {
          const ro = new ResizeObserver(updateNav);
          ro.observe(track);
          ro.observe(container);
        }
        requestAnimationFrame(() => requestAnimationFrame(updateNav));
      });
    }

    function refreshSwatchNav() {
      if (!swatchNavActive) return;
      swatchNavUpdaters.forEach((fn) => fn());
    }

    function refreshSwatchNavAfterShow() {
      let settled = false;
      const run = () => {
        if (settled || !isStickyShown) return;
        settled = true;
        sticky.removeEventListener('transitionend', onTransitionEnd);
        swatchNavActive = true;
        refreshSwatchNav();
        updateBodyPadding();
      };
      const onTransitionEnd = (e) => {
        if (e.target !== sticky) return;
        if (e.propertyName && e.propertyName !== 'transform') return;
        run();
      };
      sticky.addEventListener('transitionend', onTransitionEnd);
      setTimeout(run, 400);
    }

    function buildStickyVariants() {
      const mainRoot = getMainVariantsRoot();
      if (!mainRoot || !variantsMount) return;

      swatchNavUpdaters.length = 0;
      variantsMount.innerHTML = mainRoot.outerHTML;
      const stickyRoot = getStickyVariantsRoot();
      if (!stickyRoot) return;

      stickyRoot.querySelectorAll('input').forEach((input) => {
        const mainId = input.id;
        input.removeAttribute('name');
        input.setAttribute('tabindex', '-1');
        input.setAttribute('aria-hidden', 'true');
        if (mainId) input.dataset.mainInputId = mainId;
      });

      stickyRoot.querySelectorAll('label').forEach((label) => {
        const forId = label.getAttribute('for');
        if (forId) {
          label.dataset.mainFor = forId;
          label.removeAttribute('for');
        }
        label.setAttribute('role', 'button');
        label.setAttribute('tabindex', '0');
      });

      setupStickySwatchScroll(stickyRoot);
    }

    function syncStickyFromMain() {
      if (syncing) return;
      syncing = true;

      const mainRoot = getMainVariantsRoot();
      const stickyRoot = getStickyVariantsRoot();
      if (!mainRoot || !stickyRoot) {
        syncing = false;
        return;
      }

      const mainGroups = mainRoot.querySelectorAll('.product-variant');
      const stickyGroups = stickyRoot.querySelectorAll('.product-variant');

      mainGroups.forEach((mainGroup, groupIndex) => {
        const stickyGroup = stickyGroups[groupIndex];
        if (!stickyGroup) return;

        const mainShade = mainGroup.querySelector('.concealer-selected-shade span');
        const stickyShade = stickyGroup.querySelector(
          '.concealer-selected-shade span'
        );
        if (mainShade && stickyShade) {
          stickyShade.textContent = mainShade.textContent;
        }

        const mainItems = mainGroup.querySelectorAll('.product-variant__item');
        const stickyItems = stickyGroup.querySelectorAll('.product-variant__item');

        mainItems.forEach((mainItem, itemIndex) => {
          const stickyItem = stickyItems[itemIndex];
          if (!stickyItem) return;

          const mainInput = mainItem.querySelector('.product-variant__input');
          const stickyInput = stickyItem.querySelector('.product-variant__input');
          const mainLabel = mainItem.querySelector('.product-variant__label');
          const stickyLabel = stickyItem.querySelector('.product-variant__label');

          if (mainInput && stickyInput) {
            stickyInput.checked = mainInput.checked;
          }
          if (mainLabel && stickyLabel) {
            stickyLabel.classList.toggle(
              'selected-var',
              mainLabel.classList.contains('selected-var')
            );
          }
        });
      });

      syncing = false;
    }

    function applyMainVariantSelection(mainInput, stickyLabel) {
      const value = mainInput.value;
      const mainItem = mainInput.closest('.product-variant__item');
      const mainGroup = mainInput.closest('.product-variant');
      const stickyGroup = stickyLabel?.closest('.product-variant');
      const stickyItem = stickyLabel?.closest('.product-variant__item');

      mainGroup?.querySelectorAll('.product-variant__label').forEach((label) => {
        label.classList.remove('selected-var');
      });
      mainItem?.querySelector('.product-variant__label')?.classList.add('selected-var');

      mainInput.checked = true;
      mainInput.dispatchEvent(new Event('change', { bubbles: true }));

      updateShadeLabelInGroup(mainGroup, value);
      updateShadeLabelInGroup(stickyGroup, value);

      if (stickyItem && stickyLabel) {
        stickyGroup?.querySelectorAll('.product-variant__label').forEach((label) => {
          label.classList.remove('selected-var');
        });
        stickyLabel.classList.add('selected-var');
        const stickyInput = stickyItem.querySelector('.product-variant__input');
        if (stickyInput) stickyInput.checked = true;
      }

      requestAnimationFrame(syncStickyFromMain);
    }

    function selectMainVariantFromSticky(stickyLabel) {
      const mainFor = stickyLabel.dataset.mainFor;
      if (mainFor) {
        const mainInput = document.getElementById(mainFor);
        if (mainInput) {
          applyMainVariantSelection(mainInput, stickyLabel);
          return;
        }
      }

      const stickyItem = stickyLabel.closest('.product-variant__item');
      const stickyGroup = stickyLabel.closest('.product-variant');
      if (!stickyItem || !stickyGroup) return;

      const mainRoot = getMainVariantsRoot();
      if (!mainRoot) return;

      const stickyGroups = Array.from(
        getStickyVariantsRoot()?.querySelectorAll('.product-variant') || []
      );
      const mainGroups = Array.from(mainRoot.querySelectorAll('.product-variant'));
      const groupIndex = stickyGroups.indexOf(stickyGroup);
      const mainGroup = mainGroups[groupIndex];
      if (!mainGroup) return;

      const dataAttr = stickyItem.getAttribute('data-attr');
      const value = stickyItem.querySelector('.product-variant__input')?.value;
      let mainItem = null;

      if (dataAttr) {
        const safeAttr =
          typeof CSS !== 'undefined' && CSS.escape
            ? CSS.escape(dataAttr)
            : dataAttr.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
        mainItem = mainGroup.querySelector(
          `.product-variant__item[data-attr="${safeAttr}"]`
        );
      }

      if (!mainItem && value) {
        mainGroup.querySelectorAll('.product-variant__item').forEach((item) => {
          const input = item.querySelector('.product-variant__input');
          if (input?.value === value) mainItem = item;
        });
      }

      const mainInput = mainItem?.querySelector('.product-variant__input');
      if (mainInput) {
        applyMainVariantSelection(mainInput, stickyLabel);
      }
    }

    function updateStickyImage(variant) {
      if (!imageEl || !variant) return;

      let src = null;
      if (variant.featured_image?.src) {
        src = variant.featured_image.src;
      } else if (variant.featured_media?.preview_image?.src) {
        src = variant.featured_media.preview_image.src;
      }

      if (src) {
        const url = new URL(src, window.location.origin);
        url.searchParams.set('width', '160');
        imageEl.src = url.toString();
      }

      if (variant.name) {
        imageEl.alt = variant.name;
      }
    }

    function syncAtcButtonFromMain() {
      if (!stickyBtn) return;
      const sourceBtn = mainAtcButton || mainAtc;
      stickyBtn.classList.toggle('disabled', sourceBtn.classList.contains('disabled'));
      stickyBtn.disabled = sourceBtn.classList.contains('disabled');
      const sourceText = sourceBtn.querySelector?.('.add-to-cart__text');
      if (stickyBtnText && sourceText) {
        stickyBtnText.textContent = sourceText.textContent;
      }
    }

    function updateBodyPadding() {
      if (!isStickyShown) {
        document.documentElement.style.removeProperty('--sticky-atc-pdp-height');
        return;
      }

      const height = Math.ceil(sticky.offsetHeight);
      if (height > 0) {
        document.documentElement.style.setProperty(
          '--sticky-atc-pdp-height',
          `${height}px`
        );
      }
    }

    function setVisible(visible) {
      if (visible === isStickyShown) return;
      isStickyShown = visible;
      if (!visible) swatchNavActive = false;

      sticky.classList.toggle('is-visible', visible);
      sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
      document.body.classList.toggle(BODY_CLASS, visible);

      if (visible) {
        syncStickyFromMain();
        refreshSwatchNavAfterShow();
        requestAnimationFrame(() => requestAnimationFrame(updateBodyPadding));
      } else {
        document.documentElement.style.removeProperty('--sticky-atc-pdp-height');
      }
    }

    if (typeof ResizeObserver !== 'undefined') {
      const bodyPaddingObserver = new ResizeObserver(() => {
        if (isStickyShown) updateBodyPadding();
      });
      bodyPaddingObserver.observe(sticky);
    }

    window.addEventListener('resize', () => {
      if (isStickyShown) updateBodyPadding();
    });

    buildStickyVariants();
    syncStickyFromMain();
    syncAtcButtonFromMain();

    variantsMount?.addEventListener('click', (e) => {
      if (e.target.closest('.sticky-atc-pdp__swatch-nav')) return;

      const label = e.target.closest('.product-variant__label');
      if (!label || !variantsMount.contains(label)) return;
      e.preventDefault();
      e.stopPropagation();
      selectMainVariantFromSticky(label);
    });

    variantsMount?.addEventListener('keydown', (e) => {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      const label = e.target.closest('.product-variant__label');
      if (!label) return;
      e.preventDefault();
      selectMainVariantFromSticky(label);
    });

    productPage.addEventListener('change', (e) => {
      if (!e.target.matches('.product-variant__input')) return;
      if (variantsMount?.contains(e.target)) return;

      const group = e.target.closest('.product-variant');
      updateShadeLabelInGroup(group, e.target.value);
      syncStickyFromMain();
    });

    productPage.addEventListener('click', (e) => {
      if (variantsMount?.contains(e.target)) return;
      const label = e.target.closest('.product-variant__label');
      if (!label) return;

      const input = label.getAttribute('for')
        ? document.getElementById(label.getAttribute('for'))
        : label.previousElementSibling;
      const value =
        input?.value ||
        label.closest('.product-variant__item')?.querySelector(
          '.product-variant__input'
        )?.value;
      if (value) {
        updateShadeLabelInGroup(label.closest('.product-variant'), value);
      }
      requestAnimationFrame(syncStickyFromMain);
    });

    if (productVariants) {
      productVariants.addEventListener('VARIANT_CHANGE', (e) => {
        syncStickyFromMain();
        syncAtcButtonFromMain();
        if (e.target?.currentVariant) {
          updateShadeLabelsFromVariant(e.target.currentVariant);
          updateStickyImage(e.target.currentVariant);
        }
      });
    }

    const mainAtcObserver = new MutationObserver(syncAtcButtonFromMain);
    mainAtcObserver.observe(mainAtcButton || mainAtc, {
      attributes: true,
      attributeFilter: ['class', 'disabled'],
      subtree: true,
      childList: true,
    });

    function evaluateStickyVisibility() {
      if (visibilityRaf) return;
      visibilityRaf = requestAnimationFrame(() => {
        visibilityRaf = 0;

        const rect = mainAtc.getBoundingClientRect();
        const vh = window.innerHeight || document.documentElement.clientHeight;
        const showBuffer = 72;
        const hideBuffer = 48;

        const notReachedYet = rect.top >= vh;
        const inView = isStickyShown
          ? rect.top < vh - hideBuffer && rect.bottom > hideBuffer
          : rect.top < vh - showBuffer && rect.bottom > showBuffer;

        setVisible(!notReachedYet && !inView);
      });
    }

    evaluateStickyVisibility();
    window.addEventListener('scroll', evaluateStickyVisibility, { passive: true });
    window.addEventListener('resize', evaluateStickyVisibility, { passive: true });

    stickyBtn?.addEventListener('click', (e) => {
      e.preventDefault();
      const sourceBtn = mainAtcButton || mainAtc;
      if (sourceBtn.disabled || sourceBtn.classList.contains('disabled')) return;
      sourceBtn.click();
    });

    if (productVariants?.currentVariant) {
      updateShadeLabelsFromVariant(productVariants.currentVariant);
      updateStickyImage(productVariants.currentVariant);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyAtc);
  } else {
    initStickyAtc();
  }

  document.addEventListener('shopify:section:load', initStickyAtc);
})();
